<template>
  <small :style="{ color }">
    <v-icon small :color="color">{{ icon }}</v-icon>
    {{ evolutionPercentage | percentage(0) }}
  </small>
</template>

<script>
export default {
  props: {
    actual: {
      type: Number,
      required: true,
    },
    comparison: {
      type: Number,
      required: true,
    },
  },
  computed: {
    evolution() {
      return this.actual - this.comparison;
    },
    evolutionPercentage() {
      return this.evolution / this.comparison;
    },
    color() {
      if (this.evolutionPercentage === 0) return "grey";
      return this.evolutionPercentage > 0 ? "green" : "red";
    },
    icon() {
      if (this.evolutionPercentage === 0) return "mdi-minus";
      return this.evolutionPercentage > 0 ? "mdi-arrow-up" : "mdi-arrow-down";
    },
  },
};
</script>

<style>
</style>